import Vue from 'vue';

/**
 * Provides a reactive `errors` property to components that use
 * `:errors="errors"` or `:error-messages="errors"` in templates.
 *
 * Replaces VeeValidate v2's auto-injected ErrorBag.
 * Returns empty string by default (compatible with Vuetify's
 * error-messages prop which expects String|Array).
 *
 * Skips injection if the component already declares `errors` as a prop.
 */
Vue.mixin({
  beforeCreate() {
    const opts = this.$options;
    const propsDef = opts.props || {};
    const hasErrorsProp = Array.isArray(propsDef)
      ? propsDef.includes('errors')
      : Object.prototype.hasOwnProperty.call(propsDef, 'errors');

    if (!hasErrorsProp) {
      const existingData = opts.data;
      opts.data = function mergedData() {
        const base = typeof existingData === 'function'
          ? existingData.call(this)
          : (existingData || {});
        if (!Object.prototype.hasOwnProperty.call(base, 'errors')) {
          base.errors = '';
        }
        return base;
      };
    }
  },
});
